import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  payPeriodControls: {
    paddingBottom: 25,
    alignItems: "center",
  },
  downloadPdfButton: {
    fontWeight: 600,
  },
  payPeriodDetailsIcon: {
    color: theme.palette.primary.main,
    width: 30,
    paddingRight: 10,
  },
}));

export default useStyles;
